/** sessionStorage key the access token is bridged through. */
export const AUTH_TOKEN_STORAGE_KEY = 'authToken';

/** Window CustomEvent name carrying `{ token: string }` when the token changes. */
export const TOKEN_READY_EVENT = 'tokenReady';
